import React from 'react';
import './history.scss';
import ResponsiveImage from 'shared/responsive-image/responsive-image';

export function History() {
  return (
    <div className="bg_color_1">
      <div className="container margin_120_95">
        <div className="main_title">
          <h1>Наша история</h1>
          <p>История диспансера богата и разнообразна.</p>
        </div>
        <div className="row justify-content-between">
          <div className="clearfix">
            <figure>
              <ResponsiveImage
                src="/v1555154975/home/pdsm.jpg"
                className="float-start add_right_15 add_bottom_30 img-thumbnail"
                alt=""
                width={1623}
                height={1010}
              />
            </figure>
            <p>
              История создания и развития нашего диспансера, именованного
              изначально как учреждение «Пинский областной физкультурный
              диспансер» наглядно демонстрирует динамику профессионального
              подхода к медицинскому обеспечению спортсменов г.Пинска и Пинского
              района.
            </p>
            <p>
              Его открытие в 22 апреля 1950 г. с небольшим штатом, состоящим
              всего из семи сотрудников, стало датой отсчета в рождении на
              территории действующей на то время административной единицы
              Пинская область – такого значимого вида деятельности, как
              спортивная медицина. К сведению: «Пинский областной физкультурный
              диспансер» г.Пинска и Пиского района был открыт раньше чем в г.
              Бресте и г. Минске.
            </p>
            <p>
              В период становления диспансера велось постепенное укрепление
              материально-технической базы. Учитывая достижения современной
              медицины кабинеты окулиста, ЛОР-врача, функциональной диагностики
              имеют прекрасное техническое оснащение. В диспансере появился
              ультразвуковой аппарат высокого класса, собственное ЛОР-место
              нового поколения. Закуплено современное оборудование для работы
              врача-офтальмолога (щелевая лампа, авторефрактокератометр,
              индикатор внутриглазного давления, периметр настольный).
            </p>
            <p>
              За годы плодотворной работы усилиями специалистов проведены тысячи
              медицинских обследований спортсменов, учащихся ДЮСШ, СДЮШОР, а
              также лиц, занимающиеся в спортивных секциях города, спортивных
              школах соседних районов. Благодаря динамичному развитию
              диспансера, достигнутое максимальным использованием опыта
              врачебного персонала, возможностей новейших аппаратных комплексов,
              наше учреждение по достоинству оценивается как спортсменами, так и
              горожанами Пинска, ближайших районов, иностранными гражданами.
            </p>
            <p>
              Медицинский персонал постоянно повышает свой профессиональный
              уровень путем регулярной учебы в Академии последипломного
              образования врачей и проходя курсов повышения квалификации средних
              медработников.
            </p>
            <p>
              Медицинские технологии меняются с годами, но человеческий фактор
              будет присутствовать всегда. Учитывая, что основным нашим
              рекламным инструментом является передача положительных отзывов о
              проведенных исследованиях, мы дорожим своей репутацией и нашими
              пациентами. На текущий момент мы работаем также со страховыми
              компаниями, предлагающими оказывать медицинские услуги по
              имеющимся полисам добровольного страхования. Все активнее
              развивается и корпоративное обслуживание. Заключены и выполняются
              договоры с организациями Пинска на медицинское обслуживание,
              освидетельствование на допуск к работе их сотрудников. И снова это
              веяние времени. Сотрудники должны быть здоровыми и успешными.
              Высококлассные специалисты, новейшее оборудование, доступные цены
              – результат нашего стремления к комфортному и качественному
              обслуживанию пациентов!
            </p>
            <p>
              <em>Главврач Пётр Хлебус</em>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default History;
